// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yw0Gf","col":"styles_col__1vPeu","actions":"styles_actions__YwvYW","conflict":"styles_conflict__2r2pt"};